import { memo } from 'react';

import { workspaceAgentSkillSlashCommandChip } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentComposerChrome';

export type WorkspaceAgentSkillSlashCommandChipProps = {
  slashCommand: string;
};

export const WorkspaceAgentSkillSlashCommandChip = memo(
  ({ slashCommand }: WorkspaceAgentSkillSlashCommandChipProps) => {
    return (
      <span className={workspaceAgentSkillSlashCommandChip()}>
        <span className="truncate">/{slashCommand}</span>
      </span>
    );
  },
);

WorkspaceAgentSkillSlashCommandChip.displayName = 'WorkspaceAgentSkillSlashCommandChip';
